navigator.serviceWorker.getRegistrations()
  .then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister()
    }
  })
  .catch(e => console.warn('Service worker unregistration failed', e))

